import { c as _c } from "react/compiler-runtime";
import { SidebarHoverCardMenuItem as SharedSidebarHoverCardMenuItem, type SidebarHoverCardMenuItemProps, type SidebarNavSubItem } from "@repo/blacksmith-ui/sidebar-nav";
import { RoutePrefetchLink } from "../ui/route-prefetch-link";

/** The shared hover-card row with its sub-pages linked through the dashboard router. */
export function SidebarHoverCardMenuItem(t0) {
  const $ = _c(8);
  let prefetchOnIntent;
  let props;
  if ($[0] !== t0) {
    ({
      prefetchOnIntent,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = prefetchOnIntent;
    $[2] = props;
  } else {
    prefetchOnIntent = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== prefetchOnIntent) {
    t1 = linkProps => <RoutePrefetchLink {...linkProps} prefetchOnIntent={prefetchOnIntent} />;
    $[3] = prefetchOnIntent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <SharedSidebarHoverCardMenuItem {...props} renderLink={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}